import { NewRequest } from "../../models/resume/newRequest";

/**
 * Pure replacement for the old `ResumeDataService.createHeadingData`. Shapes the
 * HEADING section into the exact wire payload the backend expects — including
 * the required template-id encoding (`_` -> `x`, `${experience}q` prefix) and
 * the experience word -> number mapping performed by `NewRequest`.
 *
 * Unlike the legacy method it does NOT mutate its input.
 *
 * @param {{ data: { contactInfo: object, templateId: string, yearsOfExperience: unknown, resumeTitle: string } }} inputData
 */
export function buildHeadingPayload(inputData) {
	const contactInformation = {
		...inputData.data.contactInfo,
		templateId: inputData.data.templateId,
		yearsOfExperience: inputData.data.yearsOfExperience,
		resumeTitle: inputData.data.resumeTitle,
	};

	return new NewRequest(contactInformation).getRequestParam();
}
